import { render, staticRenderFns } from "./bazi.vue?vue&type=template&id=bce3a1b8&scoped=true"
var script = {}
import style0 from "./bazi.vue?vue&type=style&index=0&id=bce3a1b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce3a1b8",
  null
  
)

export default component.exports